import * as React from 'react'
import { Formik, Form, Field } from 'formik'
import { FormiikField } from '$views/components/Forms/FormiikField'
import {
  validateFieldForm,
  validatePassword,
  validateEmail,
  validateName,
  validatePhone,
} from './CustomerRegisterForm.validators'
import { Button } from '$views/components/Button'
import { Block } from '$views/components/Layout/Block'
import { Text } from '$views/components/Text'
import { CustomerRegistrationFormValues } from './CustomerRegisterForm.model'
import { FormContainer } from '$views/components/FormContainer'
import { Checkbox } from '$views/components/Checkbox'
import { Link } from '$views/components/Link'
import { guest } from '$utils/services/guestUserService'

interface Props {
  submitButtonText: string
  onBlur: (event) => void
  onSubmit: (customerRegistration: CustomerRegistrationFormValues) => void
  fluid?: boolean
  isTermsAndPolicyAccept: boolean
  setTermsAndPolicyAccept: () => void
  onClickPrivacyPolicy: () => void
  hidePhoneField?: boolean
}

export const CustomerRegisterFormView: React.SFC<Props> = ({
  onBlur,
  onSubmit,
  fluid,
  submitButtonText,
  isTermsAndPolicyAccept,
  setTermsAndPolicyAccept,
  onClickPrivacyPolicy,
  hidePhoneField,
}) => (
  <FormContainer>
    <Formik
      initialValues={{ email: guest.getEmail(), name: guest.getName(), phone: '', password: '', checkPassword: '' }}
      onSubmit={onSubmit}
      validateOnBlur={false}
      validateOnChange={true}
      validate={validateFieldForm}
      render={() => (
        <Form>
          <Field
            name="name"
            component={FormiikField}
            onBlur={onBlur}
            placeholder={'Tu nombre'}
            validate={validateName}
            primary="true"
            maxLength={100}
          />
          <Field
            name="email"
            component={FormiikField}
            onBlur={onBlur}
            type="email"
            placeholder={'Tu email'}
            validate={validateEmail}
            primary="true"
            maxLength={100}
          />
          {!hidePhoneField && (
            <Field
              name="phone"
              component={FormiikField}
              onBlur={onBlur}
              placeholder={'Móvil'}
              validate={validatePhone}
              primary="true"
              maxLength={12}
            />
          )}
          <Field
            name="password"
            component={FormiikField}
            type="password"
            placeholder={'Contraseña'}
            validate={validatePassword}
            primary="true"
          />
          <Field
            name="checkPassword"
            component={FormiikField}
            type="password"
            placeholder={'Repetir contraseña'}
            validate={validatePassword}
            primary="true"
          />
          <Block flex>
            <Block marginTop="base">
              <Checkbox
                isChecked={() => isTermsAndPolicyAccept}
                color="darkGrey"
                onChange={setTermsAndPolicyAccept}
                square
                test-id="termsAndPolicy"
              />
            </Block>
            <Text menu as="p" textAlign="left">
              Acepto el uso de mis datos en Familiados para la prestación de este servicio.{' '}
              <Link href="#" onClick={onClickPrivacyPolicy}>
                Más información
              </Link>
            </Text>
          </Block>
          <Block marginTop="small">
            <Button primary fluid={fluid} type="submit">
              {submitButtonText}
            </Button>
          </Block>
        </Form>
      )}
    />
  </FormContainer>
)



// WEBPACK FOOTER //
// ./src/views/components/Forms/CustomerRegisterForm/CustomerRegisterForm.view.tsx